__turbopack_context__.v({
  "videoContent": "styles-module-scss-module__ZyYobW__videoContent",
  "videosSet": "styles-module-scss-module__ZyYobW__videosSet",
});
